var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import React, { useEffect } from 'react';
import { ActivityIndicator, StyleSheet, Text, View } from 'react-native';
import { ScreenLayout } from '@/components/ScreenLayout';
import useAppComponents from '@/hooks/useAppComponents';
import { ResolveSharedPlaceLinkResultStatusDto } from '@/generated-sources/openapi';
import ToastUtils from '@/utils/ToastUtils';
export default function ResolvingSharedLinkScreen({ navigation, route }) {
    const { sharedText } = route.params;
    const { api } = useAppComponents();
    useEffect(() => {
        let cancelled = false;
        function resolve() {
            return __awaiter(this, void 0, void 0, function* () {
                var _a;
                try {
                    const res = yield api.resolveSharedPlaceLinkPost({
                        sharedText,
                    });
                    const data = res.data;
                    if (cancelled) {
                        return;
                    }
                    switch (data.status) {
                        case ResolveSharedPlaceLinkResultStatusDto.Matched:
                            navigation.replace('PlaceDetailV2', {
                                placeInfo: { placeId: data.place.place.id },
                            });
                            break;
                        case ResolveSharedPlaceLinkResultStatusDto.Ambiguous: {
                            // TODO: 바텀시트 후보 선택. 지금은 첫 번째 후보로 랜딩
                            const firstCandidate = (_a = data.candidates) === null || _a === void 0 ? void 0 : _a[0];
                            if (!firstCandidate) {
                                navigation.goBack();
                                break;
                            }
                            navigation.replace('PlaceDetailV2', {
                                placeInfo: { placeId: firstCandidate.place.id },
                            });
                            break;
                        }
                        case ResolveSharedPlaceLinkResultStatusDto.NotFound:
                            ToastUtils.show('공유된 장소를 찾지 못했어요.');
                            navigation.goBack();
                            break;
                        default: {
                            const _exhaustiveCheck = data.status;
                            navigation.goBack();
                            return _exhaustiveCheck;
                        }
                    }
                }
                catch (_b) {
                    if (!cancelled) {
                        navigation.goBack();
                    }
                }
            });
        }
        resolve();
        return () => {
            cancelled = true;
        };
    }, [sharedText, api, navigation]);
    return (_jsx(ScreenLayout, { isHeaderVisible: false, children: _jsxs(View, { style: styles.container, children: [_jsx(ActivityIndicator, { size: "large" }), _jsx(Text, { style: styles.message, children: '장소를 찾는 중입니다\n잠시만 기다려주세요...' })] }) }));
}
const styles = StyleSheet.create({
    container: { flex: 1, justifyContent: 'center', alignItems: 'center', gap: 16 },
    message: { fontSize: 15, color: '#666', textAlign: 'center', lineHeight: 22 },
});
